import RADApplication from '@/Management/RADApplication';
import { ImageSpriteParams } from '#/CoreFrameInterfaces';

export default class ImageHandler {

    /**
     * Gecachte SVG-Sourcen
     */
    private static svgSources = {};

    /**
     * Asynchrone Methode, die auf die Sprite-Generierung wartet und die entsprechenden Parameter zur�ckliefer
     * @param iconUrl       URL des Bildes
     * @param width         Breite des Bildes
     * @param height        H�he des Bildes
     * @param isFileType    Wird bis zum entsprechenden Handler durchgereicht
     */
    public static getParameters(iconUrl: string, width: number | string, height: number | string, isFileType: boolean): JQueryDeferred<ImageSpriteParams> {
        // Neues Deferred, da .done() keine R�ckgabe erlaubt.
        // .done() ist hier notwendig, da RADApplication.menuSpriteLoaded schon fertig sein kann,
        // ein .then() w�rde dann nicht mehr ausgel�st werden
        let deferred = $.Deferred();

        // $.when muss hier genutzt werden, da menuSpriteLoaded noch nicht initialisiert sein kann
        $.when(RADApplication.getInstance().menuSpriteLoaded).done(() => {
            let params: ImageSpriteParams = {
                source: ImageHandler.convertSource(iconUrl, isFileType),
                style: ''
            };

            if (width != null) {
                if (typeof width === 'string' && width.indexOf('px') > -1)
                    params.style += `width: ${width};`
                else
                    params.style += `width: ${width}px;`;
            }

            if (height != null) {
                if (typeof height === 'string' && height.indexOf('px') > -1)
                    params.style += `height: ${height};`
                else
                    params.style += `height: ${height}px;`;
            }

            let iconName = null;
            let split = params.source.split('?');

            if (split.length > 1) {
                split = split[1].split('&');
            }

            for (let part of split) {
                let thisParam = part.split('='),
                    name = thisParam[0],
                    value = thisParam[1];

                if (name === 'ID' || name === 'ImageName') {
                    iconName = value;
                }
            }

            if (iconName == null) {
                deferred.resolve(params);
                return;
            }

            let imageMapEntry: string = RADApplication.getInstance().menuSprite ? RADApplication.getInstance().menuSprite.imageMap[iconName] : null;
            let svgMapEntry: string = RADApplication.getInstance().menuSprite ? RADApplication.getInstance().menuSprite.svgMap[iconName] : null;
            let cachedSvgSource: string = ImageHandler.svgSources[iconName];

            // Bild wurde nicht gefunden
            if (imageMapEntry == null) {
                // SVG wurde auch nicht gefunden
                if (svgMapEntry == null) {
                    if (cachedSvgSource == null) {
                        // Bild laden, um ein SVG einbetten zu k�nnen
                        $.get(params.source, (data: any, status: JQuery.Ajax.SuccessTextStatus, request: JQuery.jqXHR) => {
                            let mimeType = request.getResponseHeader('content-type');
                            if (mimeType === 'image/svg+xml') {
                                params.source = null;
                                params.svgSource = request.responseText;
                                ImageHandler.svgSources[iconName] = params.svgSource;
                            }

                            deferred.resolve(params);
                        });
                    }
                    else {
                        params.source = null;
                        params.svgSource = cachedSvgSource;
                        deferred.resolve(params);
                    }
                }
                else {
                    params.source = null;
                    params.svgSource = svgMapEntry;    
                    deferred.resolve(params);
                }

                return;
            }

            let values = imageMapEntry.split(',').map(x => parseInt(x)),
                source = ImageHandler.convertSource(RADApplication.getInstance().menuSprite.spriteURL);

            if (width == null || width === values[2] && height == null || height === values[3]) {
                let buildedSource = ImageHandler.buildSource('blank.png');

                buildedSource = buildedSource.replace('$$DATA_HANDLER$$', RADApplication.getInstance().radEnvironmentDataHandler);
                buildedSource = buildedSource.replace('$$TEMPLATE_HANDLER$$', RADApplication.getInstance().radEnvironmentTemplateHandler);
                buildedSource = buildedSource.replace('$$TEMPLATE_STYLE$$', RADApplication.getInstance().templateStyle() + '_HTML5');
                params = {
                    source: buildedSource,
                    style: `background-image: url(${source}); background-position: -${values[0]}px -${values[1]}px; width: ${values[2]}px; height: ${values[3]}px;`
                };
            }

            deferred.resolve(params);
        });

        return deferred;
    }

    public static convertSource(source: string, isFileType?: boolean): string {
        source = source || '';

        if (source.indexOf('http://') === -1 && source.indexOf('$$TEMPLATE_HANDLER$$') === -1 && source.indexOf('TemplateHandler') === -1 && source.indexOf('$$DATA_HANDLER$$') === -1 && source.indexOf('DataHandler') === -1) {
            source = ImageHandler.buildSource(source, isFileType);
        }

        if (source.indexOf('BLANK') > -1) {
            source = ImageHandler.buildSource('blank.png');
        }

        source = source.replace('$$DATA_HANDLER$$', RADApplication.getInstance().radEnvironmentDataHandler);
        source = source.replace('$$TEMPLATE_HANDLER$$', RADApplication.getInstance().radEnvironmentTemplateHandler);
        source = source.replace('$$TEMPLATE_STYLE$$', RADApplication.getInstance().templateStyle() + '_HTML5');

        return source;
    }

    public static buildSource(image: string, isFileType?: boolean): string {
        let source = `$$TEMPLATE_HANDLER$$?TemplateName=$$TEMPLATE_STYLE$$&ImageName=${image}`;

        if (isFileType === true) {
            source += '&IsFileType=true';
        }

        return source;
    }

    public static parseImageNameFromURL(url: string) {
        if (url.indexOf('?') == -1)
            return '';

        const postFix = url.split('?')[1];
        const foundParam = postFix.split('&').map((value) => value.split('=')).filter((value) => value[0] == 'ImageName');

        if (foundParam.length == 1) {
            return foundParam[0][1];
        }
        else {
            return '';
        }
    }

    public static parseHTML(html: string): string {
        if (html != null) {
            return html.replace(/\$\$_IMAGES_\$\$\//g, RADApplication.getInstance().radEnvironmentTemplateHandler + '?TemplateName=' + RADApplication.getInstance().templateStyle() + '_HTML5&ImageName=');
        }

        return null;
    }

    public static resolve(path: string): string {
        return RADApplication.getInstance().radEnvironmentTemplateHandler + '?TemplateName=' + RADApplication.getInstance().templateStyle() + '_HTML5&ImageName=' + path;
    }

}